import { Grid, IconButton, Tooltip } from "@mui/material";
import { IconPencil } from "@tabler/icons-react";
import Streak from "./Streak";
import useCustomNavigation from "hooks/customNavigation";

export interface UserData {
  id?: string;
  name?: string;
  username?: {
    display?: string;
    standardized?: string;
  };
  streak?: number;
  streakInDanger?: boolean;
  active?: boolean;
}

export interface UserCardHeaderActionsProps {
  user: UserData;
  isCurrentUser: boolean;
}

const UserCardHeaderActions = ({
  user,
  isCurrentUser,
}: UserCardHeaderActionsProps) => {
  const navigate = useCustomNavigation();

  // On your own card the streak is already shown in the header, so offer a
  // quick edit shortcut to the profile page instead.
  if (isCurrentUser) {
    return (
      <Grid container alignItems="center">
        <Tooltip title="Edit profile">
          <IconButton
            size="small"
            aria-label="Edit profile"
            onClick={(e) => {
              e.stopPropagation();
              navigate("profile");
            }}
          >
            <IconPencil size={24} />
          </IconButton>
        </Tooltip>
      </Grid>
    );
  }

  return (
    <Grid container alignItems="center">
      <Streak user={user} isCurrentUser={isCurrentUser} variant="compact" />
    </Grid>
  );
};

export default UserCardHeaderActions;
